export default __webpack_public_path__ + "07427682b69fc48750a03012b341af94.png";